import { createApiCall } from 'lib/base';

const FETCH_INVESTCORE_NOTIFICATION_LOG_DETAIL_API_ID =
  'DASHBOARD/FETCH_INVESTCORE_NOTIFICATION_LOG_DETAIL_API';

const apiCall = createApiCall(
  FETCH_INVESTCORE_NOTIFICATION_LOG_DETAIL_API_ID,
  ({ id }: { id: string }) => ({
    endpoint: `/api/admin/notification-logs/${id}`,
    method: 'GET',
  })
);

export default apiCall;
